// Ler variável de ambiente do Vite (agora configurado para ler da raiz do projeto)
const VITE_API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export const API_CONFIG = {
  BASE_URL: VITE_API_URL,
  API_URL: VITE_API_URL, // Alias para compatibilidade
  ENDPOINTS: {
    AUTH: '/auth',
    LOGIN: '/auth/login',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    PROFILE: '/auth/profile',
    REFRESH_TOKEN: '/auth/refresh',
  },
  TIMEOUT: 10000,
}

export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`
}

export const getAuthHeaders = (token?: string) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  return headers
}
